import {connect} from "react-redux";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {bindActionCreators, Dispatch} from "redux";

import {Checkbox} from "@pg-design/checkbox-module";
import {borderRadius, calculateRemSize, flex, flexDirection, p, ph, pv, w100} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";
import {FormActions} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {
    IPropertyConfiguratorSearchFiltersFormValues,
    propertyConfiguratorSearchFormActions,
    propertyConfiguratorSearchFormFields
} from "../../reducers/property_configurator_reducer";
import {MultiCheckboxKeys} from "../../types/MultiCheckboxKeys";
import {PropertyConfiguratorSearchFormValuesType} from "../../types/PropertyConfiguratorSearchFormValuesType";

export interface IStateProps {
    formValues: PropertyConfiguratorSearchFormValuesType;
}
interface IActionsProps {
    formActions: FormActions<Record<keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
}

interface IOwnProps {
    icon: React.ComponentType<IIcon>;
    label: string;
    name: MultiCheckboxKeys;
    value: number | string;
    narrow?: boolean;
    onToggle?: (checked: boolean, label: string) => void;
}

interface IProps extends IStateProps, IActionsProps, IOwnProps {}

export const ConfiguratorCheckboxC = ({icon, label, name, value, narrow, onToggle, ...props}: IProps) => {
    const Icon = icon;
    const {isMobile} = useUserDevice();
    const checked = !!props.formValues[name]?.includes(value);
    const iconSize = isMobile || narrow ? "3.2" : "4.8";

    const onChange = (name: string, checked: boolean, value: string) => {
        const indexOfValue = props.formValues[name as keyof IPropertyConfiguratorSearchFiltersFormValues]?.findIndex((val: string) => val === value);
        const newValue = [...(props.formValues[name as keyof IPropertyConfiguratorSearchFiltersFormValues] || [])];

        if (indexOfValue >= 0) {
            onToggle?.(false, label);
            newValue.splice(indexOfValue, 1);
        } else {
            onToggle?.(true, label);
            newValue.push(value);
        }
        props.formActions.update({[name]: newValue});
        return newValue;
    };

    return (
        <Wrapper
            id={`${name}_${value}`}
            labelContent={
                <Container>
                    <Icon size={iconSize} wrapperSize={iconSize} wrapperColor="transparent" />
                    {label}
                </Container>
            }
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
            narrow={!!narrow}
        />
    );
};

function mapActionsToProps(dispatch: Dispatch): IActionsProps {
    return {
        formActions: bindActionCreators({...propertyConfiguratorSearchFormActions}, dispatch)
    };
}

function mapStateToProps(state: IRPStore): IStateProps {
    return {
        formValues: state.propertyConfigurator.formValues
    };
}

export const ConfiguratorCheckbox = connect(mapStateToProps, mapActionsToProps)(ConfiguratorCheckboxC);

interface WrapperProps {
    checked: boolean;
    narrow: boolean;
}

const Wrapper = styled(Checkbox)<WrapperProps>`
    ${w100};
    ${borderRadius(1)};
    background-color: ${(props) => props.theme.colors.gray[100]};
    ${flex()};
    ${flexDirection("row-reverse")};
    ${ph(2)}
    ${pv(3)}
    ${({narrow}) =>
        narrow &&
        css`
            ${p(1)}
        `};
    ${({checked, theme}) =>
        checked &&
        css`
            background-color: ${theme.colors.primary};
            border: 1px solid ${theme.colors.secondary};
        `}

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        ${p(1)};
    }
`;

const Container = styled.div`
    ${flex("center")};
    ${flexDirection("row")}
    gap: ${calculateRemSize(1)};
`;
import {connect} from "react-redux";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {bindActionCreators, Dispatch} from "redux";

import {Checkbox} from "@pg-design/checkbox-module";
import {borderRadius, calculateRemSize, flex, flexDirection, p, ph, pv, w100} from "@pg-design/helpers-css";
import {IIcon} from "@pg-design/icons-module";
import {FormActions} from "@pg-mono/form";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../../app/rp_reducer";
import {
    IPropertyConfiguratorSearchFiltersFormValues,
    propertyConfiguratorSearchFormActions,
    propertyConfiguratorSearchFormFields
} from "../../reducers/property_configurator_reducer";
import {MultiCheckboxKeys} from "../../types/MultiCheckboxKeys";
import {PropertyConfiguratorSearchFormValuesType} from "../../types/PropertyConfiguratorSearchFormValuesType";

export interface IStateProps {
    formValues: PropertyConfiguratorSearchFormValuesType;
}
interface IActionsProps {
    formActions: FormActions<Record<keyof typeof propertyConfiguratorSearchFormFields, unknown>>;
}

interface IOwnProps {
    icon: React.ComponentType<IIcon>;
    label: string;
    name: MultiCheckboxKeys;
    value: number | string;
    narrow?: boolean;
    onToggle?: (checked: boolean, label: string) => void;
}

interface IProps extends IStateProps, IActionsProps, IOwnProps {}

export const ConfiguratorCheckboxC = ({icon, label, name, value, narrow, onToggle, ...props}: IProps) => {
    const Icon = icon;
    const {isMobile} = useUserDevice();
    const checked = !!props.formValues[name]?.includes(value);
    const iconSize = isMobile || narrow ? "3.2" : "4.8";

    const onChange = (name: string, checked: boolean, value: string) => {
        const indexOfValue = props.formValues[name as keyof IPropertyConfiguratorSearchFiltersFormValues]?.findIndex((val: string) => val === value);
        const newValue = [...(props.formValues[name as keyof IPropertyConfiguratorSearchFiltersFormValues] || [])];

        if (indexOfValue >= 0) {
            onToggle?.(false, label);
            newValue.splice(indexOfValue, 1);
        } else {
            onToggle?.(true, label);
            newValue.push(value);
        }
        props.formActions.update({[name]: newValue});
        return newValue;
    };

    return (
        <Wrapper
            id={`${name}_${value}`}
            labelContent={
                <Container>
                    <Icon size={iconSize} wrapperSize={iconSize} wrapperColor="transparent" />
                    {label}
                </Container>
            }
            name={name}
            value={value}
            checked={checked}
            onChange={onChange}
            narrow={!!narrow}
        />
    );
};

function mapActionsToProps(dispatch: Dispatch): IActionsProps {
    return {
        formActions: bindActionCreators({...propertyConfiguratorSearchFormActions}, dispatch)
    };
}

function mapStateToProps(state: IRPStore): IStateProps {
    return {
        formValues: state.propertyConfigurator.formValues
    };
}

export const ConfiguratorCheckbox = connect(mapStateToProps, mapActionsToProps)(ConfiguratorCheckboxC);

interface WrapperProps {
    checked: boolean;
    narrow: boolean;
}

const Wrapper = styled(Checkbox)<WrapperProps>`
    ${w100};
    ${borderRadius(1)};
    background-color: ${(props) => props.theme.colors.gray[100]};
    ${flex()};
    ${flexDirection("row-reverse")};
    ${ph(2)}
    ${pv(3)}
    ${({narrow}) =>
        narrow &&
        css`
            ${p(1)}
        `};
    ${({checked, theme}) =>
        checked &&
        css`
            background-color: ${theme.colors.primary};
            border: 1px solid ${theme.colors.secondary};
        `}

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        ${p(1)};
    }
`;

const Container = styled.div`
    ${flex("center")};
    ${flexDirection("row")}
    gap: ${calculateRemSize(1)};
`;
